import { render, staticRenderFns } from "./KreirajGrupuField.vue?vue&type=template&id=46771967&scoped=true&"
import script from "./KreirajGrupuField.vue?vue&type=script&lang=js&"
export * from "./KreirajGrupuField.vue?vue&type=script&lang=js&"
import style0 from "./KreirajGrupuField.vue?vue&type=style&index=0&id=46771967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46771967",
  null
  
)

export default component.exports